// extracted by extract-css-chunks-webpack-plugin
module.exports = {"imagemapBannerIconContainer":"BAImZ","imagemapBannerIcon":"EjZPs","CMimagemapBannerIconContainer":"_22Ld0","CMimagemapBannerIcon":"qNFTp"};